import React from "react";
import useActiveTenants from "../hooks/useActiveTenants";

/**
 * Company picker limited to active tenants; value/onChange use the tenant company name (users.company_name).
 * onTenantChange(id) reports the selected tenant id ("" when cleared or unmatched).
 */
export default function TenantCompanySelect({
  name = "company",
  value,
  onChange,
  onTenantChange,
  required = false,
  disabled = false,
}) {
  const tenants = useActiveTenants();
  const raw = String(value || "").trim();
  const match = raw ? tenants.find((t) => t.name.toLowerCase() === raw.toLowerCase()) : null;
  const current = match ? match.name : raw;

  const handleChange = (e) => {
    onChange(e);
    if (onTenantChange) {
      const picked = tenants.find((t) => t.name === e.target.value);
      onTenantChange(picked ? picked.id : "");
    }
  };

  return (
    <select name={name} value={current} onChange={handleChange} required={required} disabled={disabled}>
      <option value="">Select Company</option>
      {current && !match ? <option value={current}>{current}</option> : null}
      {tenants.map((t) => (
        <option key={t.id} value={t.name}>
          {t.name}
        </option>
      ))}
    </select>
  );
}
